import { render, staticRenderFns } from "./RecentBuildingsCreatedChart.vue?vue&type=template&id=525d3557&scoped=true&"
import script from "./RecentBuildingsCreatedChart.vue?vue&type=script&lang=js&"
export * from "./RecentBuildingsCreatedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525d3557",
  null
  
)

export default component.exports